import React, { useState, useEffect } from 'react';
import { HOST_URL } from "./api/Api";
import styles from './MMLitePopup.module.css';

const MMLitePopup = () => {
  const [route, setRoute] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [wabaId, setWabaId] = useState('');
  const [phoneNumberId, setPhoneNumberId] = useState('');
  const [userName, setUserName] = useState('');
  const [userId, setUserId] = useState('');

  const lStorage = JSON.parse(localStorage.getItem("login"));
  const token = lStorage?.token;

  useEffect(() => {
    const user_id = lStorage?.user?.userId;
    const user_name = lStorage?.user?.username;

    if (!user_id || !token) return;

    setUserId(user_id);
    setUserName(user_name);

    const fetchData = async () => {
      try {
        const routeRes = await fetch(`${HOST_URL}/get_user_route.php`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ user_id, method: 'retrieve', token }),
        });
        const routeJson = await routeRes.json();
        if (routeJson.success) setRoute(routeJson.data);

        const wpRes = await fetch(`${HOST_URL}/wp_profile.php`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ user_id, method: 'retrieve', token }),
        });
        const wpJson = await wpRes.json();
        

        if (wpJson.success) {

          // wpJson.data.forEach(item => {
          //   console.log('messaging_limit_tier:', item.messaging_limit_tier);
          // });

          const eligible = wpJson.data.find(
            item => item.status === 1 && item.mmlite_signup === 0 && Number(item.messaging_limit_tier.replace("TIER_", "")) > 250
          );
         

          if (eligible) {
            setWabaId(eligible.waba_id);
            setPhoneNumberId(eligible.phone_number_id);
          }
        }
      } catch (err) {
        console.error('Error fetching data:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (!loading && route === 41 && wabaId && phoneNumberId) {
      setShowModal(true);
      document.body.style.overflow = 'hidden'; // lock background scroll
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [loading, route, wabaId, phoneNumberId]);

  const closeModal = () => {
    setShowModal(false);
    document.body.style.overflow = 'auto'; // unlock background scroll
  };

  if (loading || !showModal) return null;

  return (
    <div className={styles.overlay} onClick={closeModal}>
      <div
        className={styles.modal}
        onClick={(e) => e.stopPropagation()} // prevent closing on inner click
      >
        <button className={styles.close} onClick={closeModal}>×</button>

        <h5>Unlock better delivery rates with MMLite signup!</h5>

        <div className={styles.iframeWrapper}>
          <iframe
            src={`https://console.authkey.io/wabakmmlite/index.php?user_id=${userId}&user_name=${userName}&waba_id=${wabaId}&phone_number_id=${phoneNumberId}`}
            title="MMLite Signup"
            scrolling="no"   // disables iframe scrollbars
          />
        </div>
      </div>
    </div>
  );
};

export default MMLitePopup;
